const desc = `<html>
  <head>
    <meta content="text/html; charset=UTF-8" http-equiv="content-type" />
  </head>
  <body class="c5 doc-content">
    <p class="c1" dir="rtl">
      <span class="c0 bold">הפועל הצעיר</span
      ><span class="c2"> תמוז אב תרס"ח   [1908 07 30]</span>
    </p>
    <p class="c1" dir="rtl">
      <span class="c3">מפגשים עם פועלים צעירים ועם דמויות מיסטיות ברחובות</span>
    </p>
    <p class="c1 c6" dir="rtl"><span class="c4 c0"></span></p>
  </body>
</html>`;

export default desc;
